<template>
  <div id="system-publish-basic-information">
    <ipub-form ref="basic-information-form"
               :model="params"
               :rules="rules">
      <ipub-row :gutter="120">
        <ipub-col :span="4.8">
          <ipub-form-item prop="logo"
                          :label="LANGUAGE[language].publisherLogo">
            <ipub-upload @change="(e)=>{handleUpload('logo', e)}"
                         class="mar-b-20">
              <div class="upload-content">
                <img v-if="params.logo"
                     :src="`${domain}/${params.logo}`"
                     alt="">
                <ipub-icon v-else
                           type="iconAdd" />
              </div>
            </ipub-upload>
            <div class="font-color ipub-p4">Only support .png; File size need to be less than 2MB.</div>
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="7.2">
          <div>
            <ipub-form-item prop="fullName"
                            :label="LANGUAGE[language].publisherFullName">
              <ipub-input v-model.trim="params.fullName"
                          :placeholder="LANGUAGE[language].publisherFullName" />
            </ipub-form-item>
          </div>
          <div>
            <ipub-row :gutter="12">
              <ipub-col :span="6">
                <ipub-form-item prop="email"
                                label="Email">
                  <ipub-input v-model.trim="params.email"
                              placeholder="Email" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="6">
                <ipub-form-item prop="reviewLimitDay"
                                label="Reviewers Invite Interval Time Limit (days)">
                  <div slot="label"
                       class="mar-b-10 ipub-p2 fw-bd">
                    Reviewers Invite Interval Time Limit (days)
                    <ipub-tooltip placement="bottom"
                                  type="dark"
                                  class="mar-l-10 lin-h-40">
                      <div slot="title"
                           style="width:190px">
                        When inviting reviewers, the [Limited to Invite] label will be displayed if the latest invitation interval is less than the set number of days.
                      </div>
                      <ipub-icon class="ipub-cursor-pointer"
                                 type="iconInfo" />
                    </ipub-tooltip>
                  </div>
                  <ipub-input v-model.trim="params.reviewLimitDay"
                              number
                              :fixed="0"
                              placeholder="Please enter the interval at which invitations are allowed." />
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
          </div>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="3">
          <ipub-form-item prop="countryCode"
                          :label="LANGUAGE[language].country">
            <ipub-select v-model="params.countryCode"
                         search
                         :clear="true"
                         @search="countrySearch"
                         placeholder="Country">
              <ipub-select-option v-for="item in countryList"
                                  :value="item.code"
                                  :key="'countryList'+item.code">
                {{item.name}} <template v-if="item.otherName">({{item.otherName}})</template>
              </ipub-select-option>
            </ipub-select>
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="9">
          <ipub-form-item prop="website"
                          :label="LANGUAGE[language].officialWebsite">
            <ipub-input v-model.trim="params.website"
                        :placeholder="LANGUAGE[language].officialWebsite" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="12">
          <ipub-form-item prop="address"
                          :label="LANGUAGE[language].publisherAddress">
            <ipub-input v-model.trim="params.address"
                        :placeholder="LANGUAGE[language].publisherAddress" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item prop="conditionsTerms">
            <div class="ipub-p2 fw-bd mar-b-10 relative"
                 slot="label">
              {{LANGUAGE[language].termsCondition}}
              <template v-if="params.conditionsTerms">
                <ipub-tooltip placement="bottomLeft"
                              class="mar-l-10 ipub-c-p">
                  <div slot="title">
                    Copy File Address
                  </div>
                  <ipub-icon type="iconduplicate"
                             @click="handleCopyAddress(params.conditionsTerms)" />
                </ipub-tooltip>
              </template>
              <div class="right-option">
                <ipub-upload class="ipub-c-p"
                             @change="(e)=>{handleUpload('conditionsTerms', e)}">
                  <a class="link-color">Upload</a>
                </ipub-upload>
              </div>
            </div>
            <ipub-upload-input :file="params"
                               _name="conditionsTermsName"
                               _path="conditionsTerms"
                               class="mar-b-20"
                               :domain="domain"
                               @delete="delFile('conditionsTerms')"
                               @change="(e)=>{handleUpload('conditionsTerms', e)}" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item prop="useTerms">
            <div class="ipub-p2 fw-bd mar-b-10 relative"
                 slot="label">
              {{LANGUAGE[language].termsUse}}
              <template v-if="params.useTerms">
                <ipub-tooltip placement="bottomLeft"
                              class="mar-l-10 ipub-c-p">
                  <div slot="title">
                    Copy File Address
                  </div>
                  <ipub-icon type="iconduplicate"
                             @click="handleCopyAddress(params.useTerms)" />
                </ipub-tooltip>
              </template>
              <div class="right-option">
                <ipub-upload class="ipub-c-p"
                             @change="(e)=>{handleUpload('useTerms', e)}">
                  <a class="link-color">Upload</a>
                </ipub-upload>
              </div>
            </div>
            <ipub-upload-input :file="params"
                               _name="useTermsName"
                               _path="useTerms"
                               class="mar-b-20"
                               :domain="domain"
                               @delete="delFile('useTerms')"
                               @change="(e)=>{handleUpload('useTerms', e)}" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <div>
        <ipub-form-item :label="LANGUAGE[language].themeColor"
                        prop="mainColor">
          <ipub-radio-group v-model="params.mainColor">
            <ipub-radio v-for="(item, index) in colors"
                        :key="'Theme Color'+index"
                        :value="item">
              <div class="show-color-content"
                   :style="{background: item}"></div>
            </ipub-radio>
            <ipub-radio :value="personalColor">
              <div class="show-color-content"
                   :style="{background: personalColor}">
                <input type="color"
                       v-model="personalColor">
              </div>
            </ipub-radio>
            <font class="link-color ipub-p3">{{LANGUAGE[language].customsizeColor}}</font>
          </ipub-radio-group>
        </ipub-form-item>
      </div>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item prop="downloadNum"
                          :label="LANGUAGE[language].downloadNum">
            <ipub-input v-model.trim="params.downloadNum"
                        number
                        :placeholder="LANGUAGE[language].downloadNum" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="articleNum"
                          :label="LANGUAGE[language].articleNum">
            <ipub-input v-model.trim="params.articleNum"
                        number
                        :placeholder="LANGUAGE[language].articleNum" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="readNum"
                          :label="LANGUAGE[language].readNum">
            <ipub-input v-model.trim="params.readNum"
                        number
                        :placeholder="LANGUAGE[language].readNum" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <div>
        <ipub-form-item prop="info"
                        :label="LANGUAGE[language].basiceInformation">
          <ipub-textarea v-model.trim="params.info"
                         :placeholder="LANGUAGE[language].basiceInformation" />
        </ipub-form-item>
      </div>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item prop="twitter"
                          :label="LANGUAGE[language].twitter">
            <ipub-input v-model.trim="params.twitter"
                        :placeholder="LANGUAGE[language].twitter" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="facebook"
                          :label="LANGUAGE[language].facebook">
            <ipub-input v-model.trim="params.facebook"
                        :placeholder="LANGUAGE[language].facebook" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="linkedIn"
                          :label="LANGUAGE[language].linkedin">
            <ipub-input v-model.trim="params.linkedIn"
                        :placeholder="LANGUAGE[language].linkedin" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="12">
          <ipub-form-item prop="copyright"
                          :label="LANGUAGE[language].copyright">
            <ipub-input v-model.trim="params.copyright"
                        placeholder="Please enter the content for website copyright" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
    </ipub-form>
    <div class="btns">
      <!-- <ipub-button plain
                   style="width:150px"
                   @click="preview"
                   type="primary">{{LANGUAGE[language].preview}}</ipub-button> -->
      <ipub-button v-if="user.codeList&&user.codeList.includes('SYSTEM.PUBLISH.BASIC_INFORMATION.EDIT')"
                   style="width:150px;"
                   @click="submit"
                   type="primary">{{LANGUAGE[language].submit}}</ipub-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
